import script from "./UserModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__